export default __webpack_public_path__ + "locales/zh-CN/ResetApplicationDialog.json?hash=e6272592c8f0a82770fcf19c75c5b107";